import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { CellType } from '../../../../../enums/cellType';
import { scoreboardActions } from '../../../../../store/scoreboard/scoreboardSlice';
import { selectScoreboardData } from '../../../../../store/scoreboard/scoreboardSelectors';
import { fetchGetAuth } from '../../../../../utils/utils';
import { getHomeroomClassRowId } from '../../../../../ui/builders/utils';
import ScoreboardTable from '../../ScoreboardTable/ScoreboardTable';
import classes from './ClassesTab.module.css';

const TAB_CONFIG = {
  boardName: 'classes',
  tabType: 'class',
  columns: [
    { key: 'rank', type: CellType.RANK, text: 'rank', cssClass: classes.col_rank },
    { key: 'name', type: CellType.CLASS_NAME, text: 'class', cssClass: classes.col_textClassName },
    { key: 'participantsCount', type: CellType.PARTICIPANTS, text: 'participants', cssClass: classes.col_participants },
    { key: 'rankingScore', type: CellType.RANKING_SCORE, text: 'rankingScore', cssClass: classes.col_rankingScore },
  ],
  endpoint: 'Scoreboard/classes?schoolId=',
  currentIdKey: 'class',
  titleKey: 'myClassForPrincipal',
  titelKeyForDropdown: 'ClassForPrincipal',
};

const ClassesTab = () => {

  const dispatch = useDispatch();
  const { contestId } = useParams();
  const { texts } = useSelector(state => state.translate);
  const { school, user } = useSelector(state => state.auth);
  const { initClassesBoard } = useSelector(state => state.scoreboard);
  const scoreboardData = useSelector((state) => selectScoreboardData(TAB_CONFIG.boardName)(state)) ?? [];

  useEffect(() => {
    if (initClassesBoard)
      return;
    if (!contestId) return;
    //eslint-disable-next-line react-hooks/exhaustive-deps
    const fetchClasses = async () => {
      try {
        const apiUrl = `${window.config.apiUrl}/${TAB_CONFIG.endpoint}${school.id}&contestId=${contestId}`;
        const response = await fetchGetAuth(apiUrl);
        const classesArray = Array.isArray(response) ? response : [];
        dispatch(scoreboardActions.setClassesBoardData({ boards: { [TAB_CONFIG.boardName]: classesArray }, init: true }));
      } catch (error) {
        console.error('Error fetching classes scoreboard:', error);
        dispatch(scoreboardActions.setClassesBoardData({ boards: { [TAB_CONFIG.boardName]: [] }, init: true }));
      }
    };
    fetchClasses();
  }, [dispatch, TAB_CONFIG.boardName, contestId, school?.id]);

  return (
    <div className={classes.classesTab}>
      <div className={classes.tabHeader}>
        <p className={classes.tabTitleText}>{texts[TAB_CONFIG.titleKey]}</p>
      </div>
      <ScoreboardTable
        rows={scoreboardData?.map(r => ({ ...r, rowId: `${r.class}-${r.ordinal}` }))}
        boardConfig={{ columns: TAB_CONFIG.columns }}
        userRow={{ key: 'rowId', value: user?.studentkita != null ? `${user?.studentkita}-${user?.studentmakbila}` : getHomeroomClassRowId(school) }}
        tabType={TAB_CONFIG.tabType}
      />
    </div>
  );
};

export default ClassesTab;
